import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("luxati_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(e) {
    const detail = e?.response?.data?.detail;
    if (!detail) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
    return String(detail);
}

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "917878787141";
export const whatsappLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Hi LUXATI, I'd like to discuss a real estate requirement.")}`;

export const unsplashSrc = (url, w, q = 74) =>
    url && url.includes("images.unsplash.com")
        ? url.replace(/w=\d+/, `w=${w}`).replace(/q=\d+/, `q=${q}`)
        : url;

export const unsplashSrcset = (url, widths = [640, 960, 1400, 2000]) =>
    url && url.includes("images.unsplash.com")
        ? widths.map((w) => `${unsplashSrc(url, w)} ${w}w`).join(", ")
        : undefined;

export default api;
